import React, { useEffect } from 'react';
import { generatePath, useNavigate } from 'react-router-dom';
import Routing from './routes/Router';
import './styles/App.scss';
import ErrorBoundary from './components/errors';

import appInfo from './data/appInfo';

function App() {
  const navigate = useNavigate();

  useEffect(() => {
    if (appInfo.initialScreen === 'default') {
      return;
    }

    navigate(
      generatePath('/:subject/:chapter/:page')
    );
  }, []);

  return (
    <div className="App">
      <ErrorBoundary>
        <Routing />
      </ErrorBoundary>
    </div>
  );
}

export default App;
